import * as Api from '@/utils/request'

let baseURL = '',baseURL2 = '';
if (process.env.NODE_PM === 'prod') {
    baseURL = 'https://app.aigupiao.com';
    baseURL2 = 'https://mobile.aigupiao.com';
} else if (process.env.NODE_PM === 'dev') {
    baseURL = 'https://appdev.aigupiao.com';
    baseURL2 = 'https://mobiledev.aigupiao.com';
} else if (process.env.NODE_PM === 'beta') {
    baseURL = 'https://appbeta.aigupiao.com';
    baseURL2 = 'https://mobilebeta.aigupiao.com';
}


export default {


    async stockDetail(opt){
        return await Api.get({
            url:baseURL+'/goapi/match/details',
            params:{
                ...opt
            }
        })
    },
 
    //获取分享的数据
    async getShare(params){
        return await Api.get({
            url:'/H5/replica_share',
            params
        })
    },

}